import { Link } from 'react-router-dom';

import { ITableRenderCell } from 'CorePackage/TableModule/interfaces/ITableRenderCell';
import { ROUTE_KNM } from 'CorePackage/MainModule/routes/routes';
import { IKnmRaw } from 'KnmListPackage/MainModule/interfaces/IKnmRaw';

export const KnmListByPlanLastErpIdCell = ({ value }: ITableRenderCell<IKnmRaw>) => {
  if (!value || typeof value !== 'object' || !('id' in value) || !('erpId' in value)) {
    return null;
  }

  const { id, erpId } = value;

  return (
    <div>
      <Link className="shared-table-link" to={ROUTE_KNM(id)} target="_blank" rel="noopener noreferrer">
        {erpId}
      </Link>
    </div>
  );
};
